import styled from 'styled-components';


export const Container = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
`;



export const PoweredBy = styled.img`
  position: absolute;
  bottom: 0px;
  background-color: rgba(2,169,233,.2);
  right: 0px;
  padding: 2.5px;
  height: 25px;
`;





